import AxiosInstance from '../config/AxiosInstance';

export interface ProductModifierListItem {
  id: string;
  name: string;
  modifier_type: number;
  min_answer: number;
  max_answer: number;
  is_all: boolean;
  is_device: boolean;
  is_web: boolean;
  display_order: number;
  is_active: boolean;
  last_updated: string;
}

export interface ProductModifierDetail {
  modifier: {
    id: string;
    name: string;
    modifier_type: number;
    min_answer: number;
    max_answer: number;
    is_all: boolean;
    is_device: boolean;
    is_web: boolean;
    display_order: number;
    is_active: boolean;
  };
  products: { product_id: string }[];
  answers: {
    id: string;
    answer_text: string;
    product_id: string | null;
    color_code: string | null;
    display_order: number;
  }[];
}

export interface CreateProductModifierPayload {
  name: string;
  modifier_type: number;
  min_answer?: number;
  max_answer?: number;
  is_all?: boolean;
  is_device?: boolean;
  is_web?: boolean;
  display_order?: number;
  is_active?: boolean;
  products?: { product_id: string }[];
  answers?: {
    answer_text: string;
    product_id?: string | null;
    color_code?: string | null;
    display_order?: number;
    max_answer?: number;
  }[];
}

const getListProductModifiers = async (
  params?: { modifier_type?: number; is_active?: boolean; search?: string }
) => {
  const response = await AxiosInstance.get('/api/inventory/product-modifiers', { params });
  return response.data;
};

const getOneProductModifier = async (id: string) => {
  const response = await AxiosInstance.get(`/api/inventory/product-modifiers/${id}`);
  return response.data;
};

const createProductModifier = async (payload: CreateProductModifierPayload) => {
  const response = await AxiosInstance.post('/api/inventory/product-modifiers', payload);
  return response.data;
};

const updateProductModifier = async (id: string, payload: Partial<CreateProductModifierPayload>) => {
  const response = await AxiosInstance.put(`/api/inventory/product-modifiers/${id}`, payload);
  return response.data;
};

const deleteProductModifier = async (id: string) => {
  const response = await AxiosInstance.delete(`/api/inventory/product-modifiers/${id}`);
  return response.data;
};

export {
  getListProductModifiers,
  getOneProductModifier,
  createProductModifier,
  updateProductModifier,
  deleteProductModifier,
};
